<template>
  <section>
    <div class="container">
      <h1 class="is-size-1 has-text-weight-bold has-text-centered">Submit Fault Report</h1>
      <p v-if="locationName" class="is-size-5 has-text-centered">Location: {{ locationName }}</p>
      <p v-if="assetIdentifier" class="is-size-5 has-text-centered">Asset: {{ assetIdentifier }}</p>
      <div v-if="errorMsg" class="notification is-danger">
        <button class="delete" @click="$router.push('/manual')"></button>
        {{ errorMsg }}<br />
        <a @click="$router.push('/manual')">Click here to try entering the code again.</a>
      </div>
      <div v-if="!errorMsg" class="form">
        <div class="field is-horizontal">
          <label class="field-label is-medium">Summary of fault</label>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input v-model="descriptionConcise" class="input is-medium" type="text" placeholder="Summary" required>
              </div>
              <p class="help">Please enter a short summary of the problem.</p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <label class="field-label is-medium">Full description of fault</label>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <textarea v-model="descriptionFull" class="textarea is-medium" type="text" placeholder="Description" required></textarea>
              </div>
              <p class="help">Please provide a full description of the problem.</p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label">Receive updates regarding this fault?</div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <input v-model="updates" type="checkbox">
              </p>
            </div>
          </div>
        </div>
        <transition-group name="rollout">
          <div v-if="updates" key="email" class="field is-horizontal">
            <label class="field-label is-medium">Notification Email</label>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input v-model="notify_email" class="input is-medium" type="email" placeholder="tomato@sandwich.yum">
                </div>
              </div>
            </div>
          </div>
          <div v-if="updates" key="sms" class="field is-horizontal">
            <label class="field-label is-medium">Notification Mobile</label>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input v-model="notify_sms" class="input is-medium" type="tel" placeholder="+441234567890">
                </div>
              </div>
            </div>
          </div>
          <div key="submit-btn" class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <button class="button is-large is-success" @click="submit">
                    Submit fault report
                  </button>
                </p>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      updates: false,
      errorMsg: null
    }
  },
  computed: {
    locationName () { return this.$store.state.inboundDetail.location_name },
    assetIdentifier () { return this.$store.state.inboundDetail.asset_identifier },
    descriptionConcise: {
      get () { return this.$store.state.newFault.descriptionConcise },
      set (val) { return this.$store.commit('UPDATE_NEWFAULT_DESCRIPTION_CONCISE', val) }
    },
    descriptionFull: {
      get () { return this.$store.state.newFault.descriptionFull },
      set (val) { return this.$store.commit('UPDATE_NEWFAULT_DESCRIPTION_FULL', val) }
    },
    notify_sms: {
      get () { return this.$store.state.newFault.notify_sms },
      set (val) { return this.$store.commit('UPDATE_NEWFAULT_NOTIFY_SMS', val) }
    },
    notify_email: {
      get () { return this.$store.state.newFault.notify_email },
      set (val) { return this.$store.commit('UPDATE_NEWFAULT_NOTIFY_EMAIL', val) }
    }
  },
  methods: {
    async findInbound () {
      try {
        const register = this.$store.dispatch('getRegisterByCode', this.$route.params.code)
        await register
        try {
          const inbound = this.$store.dispatch('getInboundDetail')
          await inbound
        } catch (e) {
          this.errorMsg = `Could not load inbound fault data. ${e.message}`
        }
      } catch (e) {
        this.errorMsg = `Lookup code ${this.$route.params.code} could not be found.`
      }
    },
    async submit () {
      try {
        const submitted = this.$store.dispatch('submitFault')
        await submitted
        this.$router.push('/success')
      } catch (e) {
        this.errorMsg = `Could not submit report: ${e.message}`
      }
    }
  },
  mounted () {
    this.findInbound()
  }
}
</script>

<style scoped lang="stylus">
input[type="checkbox"]
  width: 1.5rem
  height: 1.5rem
  filter: invert(85%) hue-rotate(80deg) brightness(2.2)

.form
  margin: 1.5rem 1rem

.rollout-enter-active, .rollout-leave-to
  transition: all 0.2s

.rollout-enter, .rollout-leave-to
  opacity: 0
  transform: translateY(-10px)

.rollout-move
  transition: transform 0.1s
</style>
